module.exports = __webpack_public_path__ + "src/fonts/NotoSans-Bold.66da3e5506238b27a79322137867fcd6.ttf";